module.exports = __webpack_public_path__ + "media/assets/images/blog/away-technician-38efff1b6651cf11db45bed7ad05e492.jpg";